import { useEffect, useMemo, useState } from "react";

import { QUALIFICATION_HISTORY_PAGE } from "../../../constants";
import useBomList from "../../../hooks/useBomList";
import useBomWizardStore from "../../../stores/bomWizardStore";
import useFileImportStore from "../../../stores/fileImportStore";
import useNavigationStore from "../../../stores/navigationStore";

export default function useDashboard() {
  const [pageTitle, setPageTitle] = useState("Your Boms");
  const { boms } = useBomList();

  useEffect(() => {
    if (boms && boms.length > 0) {
      setPageTitle("Qualification History");
    } else {
      setPageTitle("Your Boms");
    }

    return () => setPageTitle("Your Boms");
  }, [boms]);

  useEffect(() => {
    useBomWizardStore.getState().clearState();
    useFileImportStore.getState().setCurrentUnparsedBOM(null);
    useFileImportStore.getState().setHeaders(null);
  }, []);

  useEffect(() => {
    useNavigationStore.getState().setCurrentPage(QUALIFICATION_HISTORY_PAGE);
  }, []);

  return useMemo(
    () => ({
      pageTitle,
    }),
    [pageTitle],
  );
}
